import { useCallback, useState } from 'react';

const walletConnect = () => {
  const [result, setResult] = useState(null);

  const connectWallet = useCallback(async () => {
    try {
      if (!window.havah) {
        window.open(
          'https://chrome.google.com/webstore/detail/havah-wallet/cnncmdhjacpkmjmkcafchppbnpnhdmon',
        );
      } else {
        const provider = window.havah;
        if (provider !== undefined) {
          setResult(await provider.connect());

          alert('연동 성공');
        }
      }
    } catch (error) {
      console.error(`Error: ${error}`);
    }
  }, []);

  return { connectWallet, result };
};

export default walletConnect;
